import { helpers, ts } from '_core';

import { BUCKET_TYPES_ENUM } from '@local/finsera-core/src/enums';

import { DraftParams } from './types';
import { getBucketsTitle } from '../../common/utils/get-name';

export const validate = (
  params: DraftParams,
  context: ts.types.backtest.BacktestAnaylsisContext | ts.types.basket.BasketAnalysisContext,
) => {
  if (!helpers.validations.validBuckets(params.buckets)) return ['Buckets are invalid.'];

  if ('basket_id' in context && params.buckets?.type === BUCKET_TYPES_ENUM.QUANTILES) {

    if (!context?.definition?.signal_handle) {
      return ['Basket must have a Ranking signal to bucket by Quantiles.'];
    }
  }

  return [];
};

export const getName = (
  params: DraftParams,
  _context: ts.types.backtest.BacktestAnaylsisContext | ts.types.basket.BasketAnalysisContext,
  resources: ts.StoreState['resources']
) => {
  return getBucketsTitle(params.buckets, 'Bucketed Cumulative Returns', resources);
};
